import { encode } from 'uqr';

interface QrCodeProps {
  value: string;
  label: string;
  size?: number;
}

/**
 * QR code drawn locally as one SVG path. The value (a link with its key)
 * never leaves the page. Always dark on white with a quiet zone, whatever
 * the theme, so phone cameras can read it.
 */
export default function QrCode({ value, label, size = 192 }: QrCodeProps) {
  const { data, size: modules } = encode(value, { ecc: 'M', border: 4 });
  let path = '';
  data.forEach((row, y) =>
    row.forEach((dark, x) => {
      if (dark) path += `M${x} ${y}h1v1h-1z`;
    }),
  );
  return (
    <svg role="img" aria-label={label} width={size} height={size} viewBox={`0 0 ${modules} ${modules}`} shapeRendering="crispEdges">
      <rect width={modules} height={modules} fill="#ffffff" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
